module.exports = __webpack_public_path__ + "../resources/images/SkyCode_36-e6eed134f936eec6d33a8281f512e6ca.svg";